<template>
  <section class="profile">
    <div class="profile__menu">
      <!--Editar-->
      <a-tooltip>
        <template #title>Editar</template>
        <EditOutlined class="profile__icon" @click="handleEdit" />
      </a-tooltip>
      <!--Eliminar-->
      <a-tooltip>
        <template #title>Eliminar</template>
        <DeleteOutlined class="profile__icon" @click="handleDelete" />
      </a-tooltip>
    </div>
    <div
      v-if="profile.icon && profile.icon != ''"
      :class="isAdminRole ? 'profile__image-admin' : 'profile__image'"
    >
      <img
        class=""
        :src="getProfileImage(profile.icon.includes('.') ? profile.icon : `${profile.icon}.svg`)"
        alt="profile"
      />
    </div>
    <div v-else-if="profile.name == 'Administrador'" class="profile__image-admin">
      <img class="" :src="getProfileImage('lightning.svg')" alt="profile" />
    </div>
    <div v-else-if="profile.name == 'Supervisor'" class="profile__image-admin">
      <img class="" :src="getProfileImage('glass.svg')" alt="profile" />
    </div>
    <div v-else class="profile__image">
      <img class="" :src="getProfileImage('smile.svg')" alt="profile" />
    </div>
    <h4 class="profile__name">{{ profile.name }}</h4>

    <p
      :class="
        profile.observations != '' ? 'profile__description' : 'profile__description-modification'
      "
    >
      {{
        profile.observations != "" ? profile.observations : `Este perfil es de “${profile.name}”`
      }}
    </p>
    <p class="total-users">
      {{ profile.total_users }}
      {{ profile.total_users == 1 ? "usuario asignado" : "usuarios asignados" }}
    </p>
  </section>
</template>

<script>
import { EditOutlined, DeleteOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { defineComponent, createVNode } from "vue";
import { RolTypes } from "@/app/shared/utils/enums";
import { Modal } from "ant-design-vue";

export default defineComponent({
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const profiles = RolTypes;
    return {
      profiles,
    };
  },
  components: {
    EditOutlined,
    DeleteOutlined,
  },
  computed: {
    disabled() {
      return !this.profile.is_editable;
    },
    isAdminRole() {
      return this.profile.role == this.profiles.administrator;
    },
  },
  methods: {
    getProfileImage(profile) {
      return new URL(`../../assets/profiles/${profile}`, import.meta.url).href;
    },
    async handleDelete() {
      if (this.profile.total_users > 0) {
        await this.$store.dispatch("fetchProfileById", this.profile.id);
        this.$emit("onDelete");
      } else {
        this.handleConfirmationDeleteNotUser();
      }
    },
    /*Guardar este modal por si requiren confirmación antes de eliminar*/
    async handleConfirmationDeleteNotUser() {
      Modal.confirm({
        title: `¿Estás seguro de eliminar el perfil “${this.profile.name}” ?`,
        content:
          "Recuerda que ya no se visualizará este perfil y no podrás asignarle nuevos usuarios.",
        onOk: () => this.deleteConfirmProfile(),
        icon: createVNode(QuestionCircleOutlined),
        centered: true,
        okText: "Eliminar",
        cancelText: "Cancelar",
      });
    },
    async handleEdit() {
      await this.$store.dispatch("fetchProfileById", this.profile.id);
      this.$emit("onEdit");
    },
    async deleteConfirmProfile() {
      try {
        await this.$store.dispatch("deleteProfile", { id: this.profile.id });
        this.$emit("onSimpleDelete");
        this.$message.success(
          "Se ha eliminado el perfil “" + this.profile.name + "” correctamente"
        );
      } catch (error) {
        this.$message.error("Error al eliminar el perfil");
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.profile
  height: 210px
  background: $gray-2
  border-radius: 4px
  border: $border-medium

  &__menu
    text-align: end
    padding: 7px 3px 0px

  &__icon
    font-size: $font-medium
    color: $primary
    padding-right: 8px
    padding-left: 8px

  &__image-admin
    width: 40px
    height: 40px
    margin: 0px auto 4px
    display: block
    border-radius: 50px
    background-color: $blue-1

    & > img
      width: 30px
      height: 30px
      margin: 5px

  &__image
    width: 40px
    height: 40px
    margin: 0px auto 4px
    display: block
    border-radius: 50px
    background-color: $orange-1

    & > img
      width: 30px
      height: 30px
      margin: 5px
      filter: invert(55%) sepia(46%) saturate(1606%) hue-rotate(351deg) brightness(105%) contrast(96%)

  &__name
    text-align: center
    color: $gray-9

  &__description
    color: $gray-8
    font-size: $font-small
    padding: 0 24px 24px 24px
    text-align: center
    word-wrap: break-word
    height: 80px
    &-modification
      color: $gray-6
      font-size: $font-small
      padding: 0 24px 45px 24px
      text-align: center
      word-wrap: break-word
      height: 80px

.total-users
    color: $gray-6
    font-size: $font-small
    padding: 0 10px
    text-align: right
    font-style: italic
    line-height: 8px
</style>
